export const Device = {
    MOBILE: 768
}